import { useQuery } from '@tanstack/react-query'
import { lcCoachingApi } from '@/api/lcCoaching'

const learnerPreviewKey = (learnerId: number) => ['growth-alert', 'preview', learnerId] as const
export const growthAlertKeys = {
  learnerPreviews: learnerPreviewKey,
  preview: (learnerId: number, date?: string) =>
    [...learnerPreviewKey(learnerId), date ?? 'today'] as const,
}

/**
 * 성장알림 미리보기 조회 (LC Growth Alert Preview).
 * date 미지정 시 오늘 기준. enabled=false 또는 learnerId<=0 이면 비활성.
 */
export function useGrowthAlertPreview(
  learnerId: number,
  date: string | undefined,
  enabled: boolean,
) {
  return useQuery({
    queryKey: growthAlertKeys.preview(learnerId, date),
    queryFn: () => lcCoachingApi.getGrowthAlertPreview(learnerId, date),
    enabled: enabled && learnerId > 0,
  })
}
